import React from 'react';

import shareButtons from './../ui/share-buttons';


const Share = React.createClass({
  /**
   * Used by React as the component name
   */
  displayName: 'Share',


  /**
   * Timeout to show emojis
   */
  showTimeout: 0,


  /**
   * Pre-fill copy for sharing
   */
  shareCopy: 'They played. You tweeted. Re-live the %23NBAPlayoffs with B/R\'s "EMOJI IS LIFE"',


  /**
   * Expected propTypes
   * @prop {Boolean} touch - If browser supports touch events
   */
  propTypes: {
    touch: React.PropTypes.bool,
  },


  /**
   * Renders component
   * @returns {Object} React element
   */
  render() {
    const clickHandler = !this.props.touch ? this._openPopup : null;
    const touchEndHandler = this.props.touch ? this._openPopup : null;

    return (
      <div className='component-share'>
        <div className='text'>Share Emoji Is Life with your NBA friends</div>
        <div className='buttons'>
          <a
            onClick={this._openPopup}
            href={'https://twitter.com/share?text=' +
              this.shareCopy + '&url=' +
              encodeURIComponent(window.location.href)
            }
            title='share on twitter'
            target='_blank'
            className='button social twitter'
          >
            <img src={shareButtons.twitter} />
          </a>
          <a
            className='button'
            onClick={clickHandler}
            onTouchEnd={touchEndHandler}
            href={'http://www.facebook.com/sharer/sharer.php?s=100&p[url]=' +
              encodeURI(window.location.href) +
              '&p[title]=' + encodeURI(this.shareCopy)
            }
            title='share on facebook'
            target='_blank'
            className='button social facebook'
          >
            <img src={shareButtons.facebook} />
          </a>
        </div>
      </div>
    );
  },


  /**
   * Opens a popup window
   * @returns {undefined} undefined
   */
  _openPopup(e) {
    const target = e.currentTarget;
    const url = target.getAttribute('href');

    window.open(url, 'Share', 'width=600, height=500');

    e.stopPropagation();
    e.preventDefault();
  },
});

export default Share;



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/Share.jsx
 **/